import { wheel as wheelLibrary, IWheelEventData, TDevice, TWheelEventType } from 'feed';
import { WHEEL_CONSTANTS } from '~/actions/wheel/constants';
import RestServices from '~/api';
import { TScenario } from '~/api/data/Scenario';
import {
  getFromLocalStorage,
  getFromSessionStorage,
  saveToLocalStorage,
  saveToSessionStorage
} from '~/helpers/storage';
import { clickstreamLogger } from '~/logging';
import { getCurrentPlatformType } from '~/utils/getCurrentPlatformType';

const sessionId = RestServices.token.sessionId;

/**
 * Проверяет наличие записи в localStorage 
 * @param wheelId 
 * @returns 
 */
const hasWheelInLocalStorage = (wheelId: string): boolean => {
  return getFromLocalStorage(WHEEL_CONSTANTS.KEY_SHOWN_WHEELS, wheelId)
    ? true
    : false;
};

/**
 * Создает запись о показе колеса в localStorage
 * @param wheelId 
 */
const saveEventShowWheelToLocalStorage = (wheelId: string) => {
  saveToLocalStorage(WHEEL_CONSTANTS.KEY_SHOWN_WHEELS, wheelId, {
    time: Date.now(),
    uuid: wheelId,
    href: document.location.href,
  });
};

/**
 * Проверяет соответствие адреса страницы паттерну колеса
 * @param urlPatterns
 * @returns
 */
const isUrlPatternSame = (urlPatterns: string[] = [], wheelId: string): boolean => {
  if (!urlPatterns.length) {
    clickstreamLogger.warn(`Wheel: ${wheelId} - display parameters are not set: urlPatterns`);

    return false;
  }
  const test = urlPatterns.map((pattern: string) => {
    return pattern?.startsWith('{{') && pattern?.endsWith('}}')
      ? new RegExp(pattern.substring(2, pattern.length - 2)).test(
        location.href.replace(/\/$/, '')
      )
      : false;
  }).some(result => result);
  if (!test) {
    clickstreamLogger.warn(`Wheel: ${wheelId} - the current page does not match the parameter urlPatterns`);
  }

  return test;
};

/**
 * Получает список колес из SessionStorage
 * @returns
 */
const getWheels = (): TScenario[] => {
  const quizzes = JSON.parse(
    JSON.stringify(getFromSessionStorage(WHEEL_CONSTANTS.KEY_WHEEL_SESSION_STORAGE, 'wheelsList'))
  );
  if (quizzes) return quizzes;

  return [];
};

/**
 * Отправляет событие колеса
 * @param eventType 
 * @param wheelEventData 
 */
const sendEvent = (eventType: TWheelEventType, wheelEventData: IWheelEventData) => {
  RestServices.scenarioEvent.set('TRIGGER_EVENT', [
    { TRIGGER_UUID: wheelEventData.configuration.uuid },
    { TRIGGER_ELEMENT: eventType },
    { SESSION_ID: sessionId },
  ]);
};

/**
 * Активирует колеса
 * @param wheels 
 */
const activeWheels = (wheels: TScenario[]) => {
  wheels.forEach((wheelData: TScenario) => {
    const wheelId = wheelData.id.toString();
    // Проверка адреса и записи о показе в хранилище 
    if (isUrlPatternSame([wheelData.steps[0].check.target.URL], wheelId) && !hasWheelInLocalStorage(wheelId)) {
      // Создаем колесо
      const WheelClass = new wheelLibrary.WheelCreator(
        wheelId,
        getCurrentPlatformType() as TDevice,
        wheelData.trigger.configuration,
        {
          sectors: wheelData.trigger.extraHTML.sectors,
          arrowColor: wheelData.trigger.extraHTML.arrowColor,
          animationProps: wheelData.trigger.extraHTML.animationProps,
        },
        sendEvent
      );
      // Запуск интервала
      const interval = parseInt(wheelData.steps[1].check.time.split(' ')[1], 10);
      setTimeout(() => {
        WheelClass.start();
        saveEventShowWheelToLocalStorage(wheelId);
      }, interval);
    }
  });
};

/**
 * Получает список колес и записывает данные в SessionStorage
 * Активирует, если данные есть
 */
const setWheelsList = (): void => {
  RestServices.scenarios.get().then((response) => {
    const wheelsList = response.payload.filter(scenario => scenario.name === 'FortuneWheel');
    saveToSessionStorage(
      WHEEL_CONSTANTS.KEY_WHEEL_SESSION_STORAGE,
      'wheelsList',
      wheelsList
    );
    if (wheelsList.length) {
      activeWheels(wheelsList);
    }
  });
};

/**
 * Инициализирует колеса при загрузке страницы
 * Проверяет данные в SessionStorage,
 * Если данных нет - получает список,
 * Если данные есть - активирует
 */
export const initWheel = (): void => {
  const wheelsList = getWheels();
  if (wheelsList.length) {
    activeWheels(wheelsList);

    return;
  }

  setWheelsList();
};